import type { IApiPath, IApiPathKey, IExtractValue } from "@api/apiPath/types";
import { apiPath } from "@api/apiPath/apiPath";

export function getApi<TPath extends IApiPathKey>(
  keyPath: TPath,
): {
  key: TPath;
  getPath: IExtractValue<IApiPath, TPath>;
} {
  const keys = keyPath.split(".") as (keyof IApiPath)[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let current: any = apiPath;

  for (const key of keys) {
    current = current[key];
  }

  return { key: keyPath, getPath: current };
}
